import React, { useEffect, useState } from "react";
import "./internetStatus.css";

const InternetStatus: React.FC = () => {
    const [statusMessage, setStatusMessage] = useState("");
    const [visible, setVisible] = useState(true);
    const [statusClass, setStatusClass] = useState("");
    const [hideTimeout, setHideTimeout] = useState<NodeJS.Timeout | null>(null);

    const hideAfterDelay = () => {
        if (hideTimeout) clearTimeout(hideTimeout);
        const timeout = setTimeout(() => setVisible(false), 2000);
        setHideTimeout(timeout);
    };

    const updateConnectionStatus = () => {
        const hasConnectionAPI = "connection" in navigator;

        const connection = hasConnectionAPI
            ? (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection
            : null;

        setVisible(true);
        setTimeout(() => {
            if (connection && connection.effectiveType) {
                switch (connection.effectiveType) {
                    case "slow-2g":
                    case "2g":
                        setStatusMessage("Internet is slow.");
                        setStatusClass("");
                        break;
                    case "3g":
                        setVisible(false);
                        setStatusMessage("")
                        break;
                    case "4g":
                        if(navigator.onLine){
                            setVisible(false);
                            setStatusMessage("")
                        }
                        break;
                    default:
                        setStatusMessage("You're online. Internet status is unknown.");
                        setStatusClass("");
                        hideAfterDelay();
                        break;
                }
            } else {
                // ******* commented for temporary ******
                // setStatusMessage("You're online. (Connection API not supported)");
                // setStatusClass("");
                // hideAfterDelay();
            }
        }, 3000);
    };

    const internetOnlineOffline = () => {
        try {
            const isOnline = typeof navigator !== "undefined" && navigator.onLine;
    
            if (isOnline) {
                setStatusMessage("You're back online!");
                setStatusClass("stable-connection");
                hideAfterDelay();
            } else {
                setStatusMessage("You're offline. Please check your internet connection.");
                setStatusClass("");
            }
        } catch (error) {
            console.error("Error checking online/offline status:", error);
            setStatusMessage("Unable to determine internet status.");
            setStatusClass("");
        }
    };

    const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
            updateConnectionStatus()
        }
    };
    

    useEffect(() => {
        window.addEventListener("online", internetOnlineOffline);
        window.addEventListener("offline", internetOnlineOffline);
        window.addEventListener("visibilitychange", handleVisibilityChange);

        const connection =
            "connection" in navigator
                ? (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection
                : null;

        if (connection && connection.addEventListener) {
            connection.addEventListener("change", updateConnectionStatus);
        }

        return () => {
            window.removeEventListener("online", internetOnlineOffline);
            window.removeEventListener("offline", internetOnlineOffline);
            window.removeEventListener("visibilitychange", handleVisibilityChange);

            if (connection && connection.removeEventListener) {
                connection.removeEventListener("change", updateConnectionStatus);
            }

            if (hideTimeout) {
                clearTimeout(hideTimeout);
            }
        };
    }, []);

    return visible ? <div className={`internet-status-wrapper ${statusClass}`}>{statusMessage ? <p>{statusMessage}</p> : null}</div> : null;
};

export default InternetStatus;
